import { AlimApi } from "api/AlimApi";
import Pagination from "components/common/Pagination";
import useTranslate from "components/language/useTranslate";
import { _PAGE_LIMIT } from "config";
import { useEffect, useState } from "react";
import { CommonTranslateErr } from "utils/axios";
import { cm_isEmpty, cm_resIsWrong } from "utils/common";

export default function AlimList() {
    const [list, setList] = useState(null);
    const alimApi = AlimApi();
    const errDic = CommonTranslateErr();

    //pagination
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const limit = _PAGE_LIMIT;
    const handleSetPage = (page) => setPage(page);

    //load
    useEffect(() => {
        handleLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[page]);

    const handleLoad = async () => {
        let skip = ((page-1) * limit);
        const res = await alimApi.getAlim({
            skip : skip,
            limit : limit
        });
        if(!cm_resIsWrong(res, errDic)){
            setList(res.data.AL_LIST);
            setTotal(res.data.LIST_TOTAL_COUNT);
        }else{
            setList([]);
            setPage(1);
            setTotal(0);
        }
    }

    const t = useTranslate();

    return(
        <>
            <div className="table1 hover-type">
                <table>
                    <colgroup>
                        <col style={{width: "10%"}}/>
                        <col style={{width: "15%"}}/>
                        <col style={{width: "15%"}}/>
                        <col style={{width: "20%"}}/>
                        <col style={{width: "20%"}}/>
                        <col style={{width: "20%"}}/>
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>ComLab Id</th>
                            <th>Labdent Id</th>
                            <th>MSEQ</th>
                            <th>STAT</th>
                            <th>REQ Time</th>
                            <th>RESULT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!cm_isEmpty(list) ?
                            list.map((comlab) => {
                                return(
                                    <tr key={`comlabAlim_seq_${comlab.id}`}>
                                        <td>{comlab.id}</td>
                                        <td>{comlab.comlab_id}</td>
                                        <td>{comlab.labdent_id}</td>
                                        <td>{comlab.mseq}</td>
                                        <td>{comlab.stat}</td>
                                        <td>{comlab.request_time}</td>
                                        <td>{comlab.result}</td>
                                    </tr>
                                )
                            })
                            :
                            <tr><td colSpan={7}>{t("tbNoResults")}</td></tr>
                        }
                    </tbody>
                </table>
            </div>

            <Pagination total={total} limit={limit} page={page} setPage={handleSetPage} />
        </>
    )
};